define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var ErrorCodes = require("codeTables/errorCodes.json");
    var SecureUtilities = require("infra-util/SecureUtilities");
    var Page = require("ui.components/page/Page");

    var ProfileModel = require("models/entities/ProfileModel");
    var ProfileEditView = require("user-management-views/profiles/ProfileEditView");
    var ProfilesFooterView = require("user-management-views/profiles/ProfilesFooterView");

    var ProfileEditController = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        ProfileEditController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            profileModel: null,
            initialize: function (options) {
                this._initialize(options);
            },

            getView: function () {
                return this.pageView;
            },
            showProfileEdit: function (profileId) {
                this._showProfileEdit(profileId);
            },

            _initialize: function (options) {
                LEUserManagement.logger.info("initializing", "ProfileEditController:initialize");
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.PROFILE_EDIT);
                this._initPageView();
                this._bindEvents();
            },

            _initPageView: function () {
                LEUserManagement.logger.debug("init page view and listen to its close", "ProfileEditController:_initPageView");
                this.pageView = new Page({
                    moduleName: LEUserManagement.moduleName,
                    context: LE.context,
                    permutation: Page.PERMUTATION.Standard,
                    contentWidth: Page.CONTENT_WIDTH.Large,
                    header: {
                        knowledgePack: {
                            text: LE.translator.translate("LEFramework.global.captions.learnMore"),
                            eventId: "working-with-profiles"
                        }
                    },
                    footer: new ProfilesFooterView()
                });
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _bindEvents: function () {
                this.listenTo(this.channel.vent, "profile:change:name", this._onNameChange);
                this.listenTo(this.channel.vent, "profile:change:description", this._onDescriptionChange);
                this.listenTo(this.channel.vent, "profile:change:role", this._oRoleChange);
                this.listenTo(this.channel.vent, "profile:change:permissions", this._onPermissionChange);
                this.listenTo(this.channel.vent, "profile:cancel", this._onCancel);
                this.listenTo(this.channel.vent, "profile:save", this._onSave);
                this.listenTo(this.channel.vent, "profile:restore:defaults", this._resetDefaultPermissions);


            },

            _showProfileEdit: function (profileId) {
                LEUserManagement.logger.info("show profile edit view", "ProfileEditController:_showProfileEdit", profileId);
                if (profileId === CONST.ROUTING.NEW_ITEM_ID) {
                    this._closeLayoutLoader();
                    this._createNewProfile();
                }
                else {
                    this._fetchProfile(profileId);
                }
            },

            _createNewProfile: function () {
                var defaultRole = ProfileModel.DEFAULT_ROLE;
                if (!LEUserManagement.hasAllProfilesViewPrivilege()) {
                    if (LEUserManagement.hasAgentProfileEditPrivilege()) {
                        defaultRole = ProfileModel.ROLES.AGENT;
                    }
                    else if (LEUserManagement.hasAgentManagerProfileEditPrivilege()) {
                        defaultRole = ProfileModel.ROLES.AGENT_MANAGER;
                    }
                }

                this.profileModel = new ProfileModel({roleTypeId: defaultRole});
                this._showView();
            },
            _fetchProfile: function (profileId) {
                this.profileModel = new ProfileModel({id: profileId});
                this._showLayoutLoader();
                this.profileModel.fetch({
                    success: _.bind(this._onFetchProfileSuccess, this),
                    error: _.bind(this._onFetchProfileError, this)
                });
            },

            _onFetchProfileSuccess: function (model, response, options) {
                LEUserManagement.logger.debug("fetch profile success", "ProfileEditController:_onFetchProfileSuccess", response);
                this._closeLayoutLoader();
                this._showView();
            },
            _onFetchProfileError: function (model, response, options) {
                LEUserManagement.logger.debug("fetch profile error closing loader returning to list", "ProfileEditController:_onFetchProfileError", response);
                this._closeLayoutLoader();
                LEUserManagement.notifier.showError({
                    content: LE.translator.translate("LEUserManagement.profileEdit.errorOnFetching.text"),
                    timeToShow: 6000
                });
                this._navigateToProfileList();
            },
            _showView: function () {
                LEUserManagement.logger.debug("show the profile edit view in the page", "ProfileEditController:_showView");
                if (this.profileModel.isNew()) {
                    this._resetDefaultPermissions();
                }
                var title = (this.profileModel.isNew()) ? LE.translator.translate("LEUserManagement.profileEdit.header.title.new") : LE.translator.translate("LEUserManagement.profileEdit.header.title.edit");
                this.insideView = new ProfileEditView({
                    model: this.profileModel
                });
                this.pageView.setTitle(title);
                this.pageView.setDescription(LE.translator.translate("LEUserManagement.profileEdit.header.description"));
                this.pageView.setInsideView(this.insideView);
            },

            _onNameChange: function (name) {
                this.profileModel.setName(name);
            },

            _onDescriptionChange: function (description) {
                this.profileModel.setDescription(description);
            },

            _oRoleChange: function (roleId) {
                this.profileModel.setRoleTypeId(roleId);
                this._resetDefaultPermissions();
            },

            _onPermissionChange: function() {
              this.profileModel.setPermissions(this.profileModel.permissionCollection.toJSON());
            },

            _resetDefaultPermissions: function() {
                var defaultModelPerCurrentRole = LEUserManagement.getDataManager().getDefaultProfilesCollection().getModelByRole(this.profileModel.getRoleTypeId());
                if (defaultModelPerCurrentRole) {
                    this.profileModel.setPermissionsCollection(defaultModelPerCurrentRole.getPermissions());
                    this.channel.trigger("profile:model:change:permissions");
                }
            },

            _onCancel: function () {
                LEUserManagement.logger.info("cancel the profile edit", "ProfileEditController:_onCancel");

                this._navigateToProfileList();
            },

            _onSave: function () {
                LEUserManagement.logger.info("save is clicked", "ProfileEditController:_onSave", this.profileModel);
                if (this.profileModel.getNumOfAssingnedUsers() > 0) {
                    var message = LE.translator.translate({
                        key: "LEUserManagement.profileEdit.saveButton.activeUsers",
                        args: [{key: SecureUtilities.escapeForHtmlContent(this.profileModel.getName()), isTranslate:false}]
                    });

                    LEUserManagement.notifier.showConfirm({
                        title: LE.translator.translate("LEFramework.global.captions.are.you.sure"),
                        content: message,
                        objectAction: {
                            text: LE.translator.translate("LEFramework.global.captions.ok"),
                            callback: _.bind(this._saveProfile, this)
                        }
                    });
                }
                else {
                    this._saveProfile();
                }
            },

            _saveProfile: function() {
                LEUserManagement.logger.info("save the profile", "ProfileEditController:_saveProfile", this.profileModel);
                this._beforeSave();
                this.profileModel.save(null, {
                    ignoreError: true,
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                });
            },

            _onSaveSuccess: function (model, resp, options) {
                LEUserManagement.logger.info("profile saved successfully", "ProfileEditController:_onSaveSuccess", model);
                LEUserManagement.getDataManager().updateCollection(model);
                this._afterSave();
                this._navigateToProfileList();
            },

            _onSaveError: function (model, resp, options) {
                LEUserManagement.logger.info("profile could not be saved", "ProfileEditController:_onSaveError", model);
                this._afterSave();
                var errorMessage = LE.translator.translate("LEFramework.something.went.wrong");
                errorMessage = _.has(resp.responseError, "message") ? resp.responseError.message : errorMessage;

                if (_.has(resp.responseError, "internalCode")){
                    if (resp.responseError.internalCode == ErrorCodes.changingLastAdminProfile) {
                        errorMessage = LE.translator.translate("LEUserManagement.profileEdit.errors.general.changingLastAdminProfile");
                    } else  if ( resp.responseError.internalCode == ErrorCodes.concurrentModificationConflict) {
                        errorMessage = LE.translator.translate("LEUserManagement.profileEdit.errors.general.conflict");
                    } else  if ( resp.responseError.internalCode == ErrorCodes.uniquenessViolation) {
                        options.errorObject = options.errorObject || {};
                        options.errorObject[model.KEYS.NAME] = LE.translator.translate("LEUserManagement.profileEdit.errors.name.duplicated");
                    } else if (resp.responseError.internalCode === ErrorCodes.noDataFound) {
                        errorMessage = LE.translator.translate("LEUserManagement.profileEdit.errors.entity.was.deleted");
                        this._onCancel();
                    }
                }

                if ((!_.isEmpty(options.errorObject))) {
                    this.channel.trigger("profile:save:error", options.errorObject);
                }

                var messageToShow = (!_.isEmpty(options.errorObject)) ? LEUserManagement.getGeneralErrorMsg(options.errorObject) : errorMessage;
                if (!_.isEmpty(messageToShow)) {
                    LEUserManagement.notifier.showError(messageToShow);
                }
            },

            _onSaveInvalid: function (model, errorObject) {
                LEUserManagement.logger.info("profile could not be saved", "ProfileEditController:_onSaveInvalid", model);

                this._afterSave();

                var translatedErrorObj = {};
                _.each(errorObject, function (value, key, obj) {
                    translatedErrorObj[key] = LE.translator.translate(value);
                });

                LEUserManagement.notifier.showError(LEUserManagement.getGeneralErrorMsg(translatedErrorObj));
                this.channel.trigger("profile:save:error", translatedErrorObj);
            },

            _beforeSave: function () {
                this._showLoader();
                this.listenTo(this.profileModel, "invalid", this._onSaveInvalid);
            },

            _afterSave: function () {
                this.stopListening(this.profileModel, "invalid");
                this._closeLoader();
            },

            _showLoader: function () {
                this.pageView.showLoader();
            },

            _closeLoader: function () {
                this.pageView.closeLoader();
            },

            _showLayoutLoader: function () {
                LEUserManagement.showLoader();
            },

            _closeLayoutLoader: function () {
                LEUserManagement.closeLoader();
            },

            _navigateToProfileList: function () {
                LEUserManagement.logger.info("navigate to profile list", "ProfileEditController:_navigateToProfileList");
                LEUserManagement.router.navigate("profiles");
            },

            _onPageClose: function () {
                LEUserManagement.logger.debug("Page component in profile edit is closed. re-init it.", "ProfileEditController:onPageClose");
                this.insideView = null;
                this.stopListening(this.pageView);
                this._initPageView();
            }

        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return ProfileEditController;
});
